import {
  AddBulkStationFormFieldsEnum,
  AddBulkStationMethodEnum,
  yupLocalized,
} from "@ryde/shared";

export const yupAddBulkStationsValidationSchema = {
  [AddBulkStationFormFieldsEnum.method]: yupLocalized
    .mixed<AddBulkStationMethodEnum>()
    .oneOf(Object.values(AddBulkStationMethodEnum))
    .nullable()
    .optional(),

  [AddBulkStationFormFieldsEnum.value]: yupLocalized
    .number()
    .optional()
    .nullable(),
  [AddBulkStationFormFieldsEnum.isSetOnlyForMissingPickup]:
    yupLocalized.boolean(),
};
